function createDownloadLink(data: Blob, filename: string){
    const url = URL.createObjectURL(data)
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click()
    URL.revokeObjectURL(url)
}

export default createDownloadLink